__webpack_require__.p = "https://static.age.awaze.com/search-mfe/080d250/_next/";